import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoadingService } from '@core/services/ui/loading.service';

@Component({
  selector: 'app-spinner-carga',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (loadingService.estaCargando()) {
      <div class="spinner-carga__overlay" aria-live="assertive" role="status">
        <div class="spinner-carga__contenido">
          <div class="spinner-carga__anillo">
            <svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="spinner-carga__pista" cx="33" cy="33" r="28" />
              <circle class="spinner-carga__indicador" cx="33" cy="33" r="28" />
            </svg>
          </div>
          <p class="spinner-carga__texto">Cargando...</p>
        </div>
      </div>
    }
  `,
  styleUrl: './spinner-carga.component.scss',
})
export class SpinnerCargaComponent {
  protected readonly loadingService = inject(LoadingService);
}
